var map = {
	"./10k-drive.svg": [
		38329,
		38329
	],
	"./18-plus.svg": [
		91644,
		91644
	],
	"./18plus.svg": [
		10595,
		10595
	],
	"./18plusMrGreen.svg": [
		94935,
		94935
	],
	"./24h.svg": [
		33086,
		33086
	],
	"./888club.svg": [
		36436,
		36436
	],
	"./888club2.svg": [
		62030,
		62030
	],
	"./888wetten.svg": [
		29257,
		29257
	],
	"./AvatarIcon.svg": [
		13628,
		35371
	],
	"./Icon-18.svg": [
		38631,
		38631
	],
	"./Sjalvtest.svg": [
		11514,
		11514
	],
	"./SjalvtestMrGreen.svg": [
		73248,
		73248
	],
	"./Spelgranser.svg": [
		15850,
		15850
	],
	"./SpelgranserMrGreen.svg": [
		464,
		464
	],
	"./Spelpaus.svg": [
		52875,
		52875
	],
	"./SpelpausMrGreen.svg": [
		62159,
		62159
	],
	"./about-us.svg": [
		7444,
		7444
	],
	"./account-statement.svg": [
		1525,
		1525
	],
	"./account.svg": [
		17653,
		17653
	],
	"./add-user.svg": [
		75535,
		75535
	],
	"./alert.svg": [
		56402,
		56402
	],
	"./app-download.svg": [
		25894,
		25894
	],
	"./az-sports.svg": [
		49087,
		49087
	],
	"./back-btn.svg": [
		84890,
		84890
	],
	"./be-gamble-aware.svg": [
		68169,
		68169
	],
	"./bell.svg": [
		37995,
		37995
	],
	"./bet-feed-old.svg": [
		36966,
		36966
	],
	"./bet-feed.svg": [
		8650,
		8650
	],
	"./betfeed-mrg.svg": [
		82106,
		82106
	],
	"./biometrics-login.svg": [
		26245,
		26245
	],
	"./blog.svg": [
		58756,
		58756
	],
	"./bonuses.svg": [
		46485,
		46485
	],
	"./burger-old.svg": [
		57295,
		57295
	],
	"./burger.svg": [
		51479,
		51479
	],
	"./casino-daily-wish.svg": [
		13123,
		13123
	],
	"./casino-game.svg": [
		69564,
		69564
	],
	"./casino-history.svg": [
		94042,
		94042
	],
	"./casino-mrg.svg": [
		99558,
		99558
	],
	"./casino-si.svg": [
		87870,
		87870
	],
	"./challanges-shield.svg": [
		73424,
		73424
	],
	"./challenges.svg": [
		46866,
		46866
	],
	"./chat.svg": [
		35514,
		35514
	],
	"./check.svg": [
		50240,
		50240
	],
	"./clock.svg": [
		79274,
		79274
	],
	"./close-x.svg": [
		65483,
		65483
	],
	"./close.svg": [
		71084,
		71084
	],
	"./confirmed.svg": [
		87187,
		87187
	],
	"./control-center.svg": [
		63891,
		63891
	],
	"./cool_arrow.svg": [
		99421,
		99421
	],
	"./cross-casino-logo.svg": [
		8492,
		8492
	],
	"./cross-poker-logo.svg": [
		12220,
		12220
	],
	"./cross-sell-casino-mobile.svg": [
		47802,
		47802
	],
	"./cross-sell-casino.svg": [
		44827,
		44827
	],
	"./cross-sell-poker-mobile.svg": [
		51616,
		51616
	],
	"./cross-sell-poker.svg": [
		61253,
		61253
	],
	"./cross-sell-sport-mobile.svg": [
		66783,
		66783
	],
	"./cross-sell-sport.svg": [
		19052,
		19052
	],
	"./cross-sport-logo.svg": [
		14971,
		14971
	],
	"./de-migration-logo.svg": [
		22918,
		22918
	],
	"./default-icon.svg": [
		73587
	],
	"./default-logo.svg": [
		58845,
		58845
	],
	"./deposit.svg": [
		85098,
		85098
	],
	"./depositLimit.svg": [
		75575,
		75575
	],
	"./dice.svg": [
		81129,
		81129
	],
	"./disconnect-error.svg": [
		1971,
		1971
	],
	"./disconnect.svg": [
		52270,
		52270
	],
	"./disconnected.svg": [
		95137,
		95137
	],
	"./document-checked.svg": [
		76775,
		76775
	],
	"./document.svg": [
		9387,
		9387
	],
	"./documentWithTimer.svg": [
		49374,
		49374
	],
	"./download-app.svg": [
		710,
		710
	],
	"./download.svg": [
		73416,
		73416
	],
	"./e-magazine.svg": [
		29600,
		29600
	],
	"./email.svg": [
		9120,
		9120
	],
	"./face-id.svg": [
		22315,
		22315
	],
	"./financial.svg": [
		45117,
		45117
	],
	"./finger-print.svg": [
		42849,
		42849
	],
	"./flag.svg": [
		92982,
		92982
	],
	"./football.svg": [
		25563,
		25563
	],
	"./free-bets.svg": [
		73331,
		73331
	],
	"./free-play.svg": [
		821,
		821
	],
	"./freespin.svg": [
		70082,
		70082
	],
	"./gam-care.svg": [
		67609,
		67609
	],
	"./game-frame-close.svg": [
		9485,
		9485
	],
	"./game-frame-eighteenplus.svg": [
		42396,
		42396
	],
	"./game-frame-expand.svg": [
		19247,
		19247
	],
	"./game-frame-shrink.svg": [
		24900,
		24900
	],
	"./games.svg": [
		79993,
		79993
	],
	"./gaming.svg": [
		8327,
		8327
	],
	"./gear.svg": [
		51049,
		51049
	],
	"./globe.svg": [
		81503,
		81503
	],
	"./green-gaming.svg": [
		30201,
		30201
	],
	"./help-link.svg": [
		52934,
		52934
	],
	"./help.svg": [
		78601,
		78601
	],
	"./history-new.svg": [
		60549,
		60549
	],
	"./history.svg": [
		28736,
		28736
	],
	"./home-new.svg": [
		84480,
		84480
	],
	"./home.svg": [
		3213,
		3213
	],
	"./hourglass.svg": [
		11958,
		11958
	],
	"./how-to-deposit.svg": [
		53369,
		53369
	],
	"./how-to-play.svg": [
		93735,
		93735
	],
	"./icon-profile.svg": [
		42483,
		42483
	],
	"./info-tip.svg": [
		19956,
		19956
	],
	"./info.svg": [
		51652,
		51652
	],
	"./inplay.svg": [
		93279,
		93279
	],
	"./invite-a-friend.svg": [
		99982,
		99982
	],
	"./leaderboard-new.svg": [
		45880,
		45880
	],
	"./light.svg": [
		98764,
		98764
	],
	"./live-now-side-menu.svg": [
		53045,
		53045
	],
	"./live-old.svg": [
		26914,
		26914
	],
	"./live.svg": [
		19286,
		19286
	],
	"./localization-language.svg": [
		60242,
		60242
	],
	"./localization-pin.svg": [
		33289,
		33289
	],
	"./location-pin.svg": [
		99943,
		99943
	],
	"./location-plugin.svg": [
		10491,
		10491
	],
	"./location-plugin_si.svg": [
		85602,
		85602
	],
	"./location-search-pin.svg": [
		41792,
		41792
	],
	"./locker.svg": [
		74212,
		74212
	],
	"./logo-18-plus.svg": [
		90430,
		90430
	],
	"./logo-DGA-spillemyndigheden.svg": [
		18338,
		18338
	],
	"./logo-SI-desktop-red-white.svg": [
		87899,
		87899
	],
	"./logo-SI-mobile-header-white.svg": [
		63273,
		63273
	],
	"./logo-abon.svg": [
		25760,
		25760
	],
	"./logo-egt.svg": [
		26134,
		26134
	],
	"./logo-mrg-mobile.svg": [
		73925,
		73925
	],
	"./logo-mrg.svg": [
		21894,
		57752
	],
	"./logo-oktocash.svg": [
		67010,
		67010
	],
	"./logo-rofus.svg": [
		66203,
		66203
	],
	"./logo-spil-ansvarligt.svg": [
		32186,
		32186
	],
	"./logo-stop-spillet.svg": [
		69360,
		69360
	],
	"./logout.svg": [
		31834,
		31834
	],
	"./map-circle.svg": [
		22295,
		22295
	],
	"./map-circle_si.svg": [
		95182,
		95182
	],
	"./menu-spinner.svg": [
		58413,
		58413
	],
	"./migrationro-hours.svg": [
		21295,
		21295
	],
	"./migrationro-oneapp.svg": [
		86783,
		86783
	],
	"./migrationro-tournaments.svg": [
		88002,
		88002
	],
	"./mobile-light.svg": [
		91237,
		91237
	],
	"./moneyWallet.svg": [
		21443,
		21443
	],
	"./more.svg": [
		66691,
		66691
	],
	"./mrgreen-myaccount-area.svg": [
		75252,
		75252
	],
	"./notification.svg": [
		29301,
		29301
	],
	"./odds.svg": [
		96958,
		96958
	],
	"./offers.svg": [
		30901,
		30901
	],
	"./perfect-10.svg": [
		11523,
		11523
	],
	"./plus-cashier-mr-green.svg": [
		89234,
		45847
	],
	"./plus-cashier.svg": [
		59388,
		12990
	],
	"./poker-history.svg": [
		89720,
		89720
	],
	"./poker-mrg.svg": [
		3880,
		3880
	],
	"./poker.svg": [
		48039,
		48039
	],
	"./pokerCards.svg": [
		7868,
		7868
	],
	"./pokerDownloadUser.svg": [
		39658,
		39658
	],
	"./poker_logo.svg": [
		60835,
		60835
	],
	"./poker_logo_mobile.svg": [
		50292,
		50292
	],
	"./popular.svg": [
		74175,
		74175
	],
	"./popupLight.svg": [
		34634,
		90609
	],
	"./promotions-prelogin.svg": [
		67029,
		67029
	],
	"./promotions.svg": [
		41218,
		41218
	],
	"./question-mark.svg": [
		16090,
		16090
	],
	"./real-money-poker.svg": [
		28291,
		28291
	],
	"./recommendations-old.svg": [
		38440,
		38440
	],
	"./recommendations.svg": [
		50768,
		50768
	],
	"./rectangle-poker.svg": [
		96895,
		96895
	],
	"./redeem-gold-token.svg": [
		62499,
		62499
	],
	"./redirect-focus.svg": [
		63907,
		63907
	],
	"./register.svg": [
		56107,
		56107
	],
	"./responsible-gaming.svg": [
		72426,
		72426
	],
	"./result_arrow.svg": [
		59637,
		59637
	],
	"./reverse-withdraw.svg": [
		45225,
		45225
	],
	"./rewards.svg": [
		84244,
		84244
	],
	"./search.svg": [
		13060,
		13060
	],
	"./security.svg": [
		94090,
		94090
	],
	"./session.svg": [
		84868,
		84868
	],
	"./shield.svg": [
		50811,
		50811
	],
	"./special-offers.svg": [
		32023,
		32023
	],
	"./sport-history.svg": [
		8645,
		8645
	],
	"./sport-mrg.svg": [
		9633,
		9633
	],
	"./sport.svg": [
		48142,
		48142
	],
	"./sport_cross_sell.svg": [
		70114,
		70114
	],
	"./sport_logo.svg": [
		62056,
		62056
	],
	"./sport_logo_VIP.svg": [
		63296,
		63296
	],
	"./sport_logo_mobile.svg": [
		6805,
		6805
	],
	"./sportwetten.svg": [
		94247,
		94247
	],
	"./sportwetten_VIP.svg": [
		90939,
		90939
	],
	"./sportwetten_mobile.svg": [
		7624,
		7624
	],
	"./star-empty.svg": [
		97484,
		97484
	],
	"./star.svg": [
		52344,
		52344
	],
	"./starting_soon.svg": [
		2018,
		2018
	],
	"./theme-mode.svg": [
		27505,
		27505
	],
	"./ticket.svg": [
		46444,
		46444
	],
	"./tickets-new.svg": [
		51482,
		51482
	],
	"./title_races.svg": [
		28709,
		28709
	],
	"./touch-id.svg": [
		56441,
		56441
	],
	"./tournament-tickets.svg": [
		22941,
		22941
	],
	"./tournaments.svg": [
		91208,
		91208
	],
	"./tribal-white.svg": [
		25324,
		25324
	],
	"./up-for-8.svg": [
		36654,
		36654
	],
	"./upload-documents.svg": [
		69094,
		69094
	],
	"./user-default-icon.svg": [
		51793,
		51793
	],
	"./user-details.svg": [
		53824,
		53824
	],
	"./user-icon-pre-login-default.svg": [
		15845,
		15845
	],
	"./user.svg": [
		62777,
		62777
	],
	"./vi-cross-sell-casino-mobile.svg": [
		59878,
		59878
	],
	"./vi-cross-sell-poker-mobile.svg": [
		81316,
		81316
	],
	"./vi-logo.svg": [
		98785,
		98785
	],
	"./virtual-sports.svg": [
		82463,
		82463
	],
	"./wallet.svg": [
		5799,
		5799
	],
	"./winloss-history.svg": [
		66492,
		66492
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 13254;
module.exports = webpackAsyncContext;